<script lang="ts">
    import { onMount, onDestroy } from 'svelte';
    import { fade } from 'svelte/transition';
    import { createEventDispatcher } from 'svelte';
    import CrossModalFooter from './cross-modal-footer.svelte';

    const dispatch = createEventDispatcher();

    const handleKeyDown = event => {
        if (event.key === 'Escape' || event.keyCode === 27) {
            dispatch('close_modal');
        }
    };

    onMount(() => {
        document.addEventListener('keydown', handleKeyDown);
    });

    onDestroy(() => {
        document.removeEventListener('keydown', handleKeyDown);
    });

    let iconClass = 'w-6 h-6 flex justify-center items-center cursor-pointer';
    let className = '';
    export { className as class };
</script>

<!-- @NOTE it is important to leave fade effects separated because of artefacts -->
<div
    class="fixed inset-0 z-[8000] bg-game-backdrop/60 hover:cursor-pointer desktop:backdrop-blur"
    on:click={() => dispatch('close_modal')}
    in:fade|global={{ duration: 100 }}
    out:fade|global={{ duration: 100 }}
/>
<div
    class="sm:p-6 md:p-20 fixed inset-0 z-9999 flex h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden desktop:left-1/2 desktop:top-1/2 desktop:h-fit desktop:w-fit desktop:-translate-x-1/2 desktop:-translate-y-[60%]"
    in:fade|global={{ duration: 100 }}
    out:fade|global={{ duration: 100 }}
>
    <div
        class="mx-auto h-full w-full overflow-hidden bg-cross-back2 desktop:h-auto desktop:w-[800px] desktop:rounded-3xl desktop:border desktop:border-cross-n-900 {className}"
    >
        <header
            class="adaptive-px mt-4 flex h-cross-modal-header-height w-full flex-shrink-0 items-center justify-between text-white desktop:mt-0 desktop:rounded-t-3xl"
            class:border-bottom={$$slots['modal-header']}
            class:cross-modal-gradient-bg={$$slots['modal-header']}
        >
            <div class="flex w-full items-center justify-between">
                <div class="flex w-full items-center justify-end gap-x-6 tablet:gap-x-8">
                    <slot name="modal-header" classSlot={iconClass} />
                    <div class="relative z-50 {iconClass}" on:click={() => dispatch('close_modal')}>
                        <!-- @TODO is it necessary? -->
                        {#if $$slots['modal-header']}
                            <div class="absolute -left-2/4 h-5 w-[1px] bg-white/50 tablet:-left-3/4" />
                        {/if}
                        <clw-icon-close />
                    </div>
                </div>
            </div>
        </header>

        <div
            class="adaptive-px content-height-mobile scroll-py-3 overflow-y-auto py-6 !font-Roboto text-white tablet:py-8 desktop:!h-[544px] desktop:min-h-[456px]"
        >
            <slot name="modal-content" />
        </div>

        <div id="portal-gradient-game-info" />

        <footer class="adaptive-px cross-modal-gradient-bg relative z-50 flex desktop:hidden">
            <slot name="modal-footer">
                <CrossModalFooter />
            </slot>
        </footer>
    </div>
</div>

<!-- @TODO - вынести в глобал и убрать отсюда -->
<style>
    :global(.cross-modal-gradient-bg) {
        background: linear-gradient(90.53deg, rgba(255, 255, 255, 0.02) 0%, rgba(0, 0, 0, 0) 100%), #101010;
    }

    .border-bottom {
        border: 0;
        border-bottom: 1px solid #ffffff05;
    }

    .content-height-mobile {
        height: calc(100% - var(--cross-modal-header-height) - var(--footer-height) - var(--session-header-height));
    }
</style>
